import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const YoutubeIcon: FC<IconProps> = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.615 2.58415C16.011 2.33815 7.98399 2.33915 4.38499 2.58415C0.488 2.85015 0.029 5.20415 0 11.4001C0.029 17.5851 0.484 19.9491 4.38499 20.2161C7.98499 20.4611 16.011 20.4621 19.615 20.2161C23.512 19.9501 23.971 17.5961 24 11.4001C23.971 5.21515 23.516 2.85115 19.615 2.58415ZM8.99999 15.4001V7.40014L17 11.3931L8.99999 15.4001Z" />
    </svg>
);